import FpChartTable from './FpChartTable.jsx'
export default FpChartTable
